export const COLORS = {
  mainThemeColor: '#2c3e50',
  diagnolColor: '#275aa2',
}
